export const ModalContent = {
  baseStyle: {
    borderRadius: "1rem",
  },
};
